var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header" }, [
        _c("img", {
          staticClass: "arrow",
          attrs: { src: "/static/arrow-prev.svg" },
          on: { click: _vm.returnPaymentOption }
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("CARTÃO DE CRÉDITO")])
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "zoom", mode: "out-in" } },
        [
          _vm.newCreditCard || !_vm.creditCards.length
            ? _c("NewCreditCard")
            : _c(
                "div",
                [
                  !_vm.newCreditCard && _vm.creditCards.length
                    ? _c("StoredCreditCard", {
                        on: { updateCanPay: _vm.updateCanPay }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-pink-ouline",
                        on: {
                          click: function($event) {
                            _vm.newCreditCard =
                              true && _vm.updatePaymentType("CREDIT_CARD")
                          }
                        }
                      },
                      [_vm._v("\n          Pagar com outro cartão\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "submit-button",
                        class: {
                          "button-disabled": _vm.cantPay,
                          "button-loading": _vm.preloader
                        },
                        attrs: { disabled: _vm.cantPay },
                        on: { click: _vm.submit }
                      },
                      [_c("span", [_vm._v("Pagar agora")])]
                    )
                  ])
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "custom-dialog",
        {
          attrs: {
            visible: _vm.dialog,
            icon: "/static/icon-alert-purple.svg",
            title: "Atualização sobre o pagamento via cartões de crédito salvos"
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("p", [
              _vm._v(
                "\n        A empresa conhecida por Moip (Antigo Wirecard Brasil) foi adquirida pelo PagSeguro. Com essa fusão, o Moip está sendo descontinuado e estamos realizando a migração dos pagamentos via cartão de crédito para utilizar as soluções oferecidas pelo PagSeguro.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [
                _vm._v(
                  "Ok, mas porque não estou vendo mais os meus cartões de crédito salvos?"
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Ao salvar um cartão de crédito para facilitar o processo de compras futuras, os dados que você informou são criptografados e apenas o meio de pagamento (Moip) que processa a transação da sua compra tem acesso a eles.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        A migração que estamos realizando do Moip para o PagSeguro, não permite mover essas informações entre as duas plataformas. Por esse motivo, caso você tenha salvo algum cartão no passado será necessário fazê-lo novamente. Entendemos que isso possa ser um pouco chato, mas esse processo garante a maior e a melhor segurança possível pra você e o seu cartão.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [
                _vm._v(
                  "Salvar o cartão no momento da compra não é obrigatório. Caso você o faça, é possível excluí-lo a qualquer momento."
                )
              ])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Caso você tenha alguma dúvida entre em contato com o nosso suporte. O nosso atendimento é de segunda à sexta das 8h às 18h e aos sábado das 8h às 14h."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "div",
                {
                  staticClass: "btn bg-purple-outline",
                  on: {
                    click: function($event) {
                      _vm.dialog = false
                    }
                  }
                },
                [_vm._v("Ok, entendi!")]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae17082e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae17082e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/PaymentOptions/CreditCard.vue
// module id = null
// module chunks = 